/* 

  HEADS UP! THIS IS A GENERATED FILE!
  
  Changes done in this file will be overwritten on next generation from the code generator.

*/
import domainModel from 'domain-model';
import getAxiosInstance from '../config/api';

const settlementDatalayer = {
  copackAgreement: {
    list: async (query, req, options) => {
      const instance = await getAxiosInstance(req);
      // the catch handle cancel events, the code for cancel is in getAxiosInstance and actions

      const result = await instance
        .post(`copackAgreements/search`, query, options)
        .catch(() => null);
      if (!result) return undefined;
      if (domainModel.copackAgreement.getViewModel) {
        result.data.rows = result.data.rows.map(row => {
          return domainModel.copackAgreement.getViewModel(row);
        });
        return result.data;
      }
      return result.data;
    },
    get: async (query, req, options) => {
      const instance = await getAxiosInstance(req);
      const result = await instance.get(
        `copackAgreements/${query.id}`,
        options,
      );
      if (domainModel.copackAgreement.getViewModel) {
        return domainModel.copackAgreement.getViewModel(result.data);
      }
      return result.data;
    },
  },

  orderBrokerageAgreement: {
    list: async (query, req, options) => {
      const instance = await getAxiosInstance(req);
      // the catch handle cancel events, the code for cancel is in getAxiosInstance and actions

      const result = await instance
        .post(`orderBrokerageAgreements/search`, query, options)
        .catch(() => null);
      if (!result) return undefined;
      if (domainModel.orderBrokerageAgreement.getViewModel) {
        result.data.rows = result.data.rows.map(row => {
          return domainModel.orderBrokerageAgreement.getViewModel(row);
        });
        return result.data;
      }
      return result.data;
    },
    get: async (query, req, options) => {
      const instance = await getAxiosInstance(req);
      const result = await instance.get(
        `orderBrokerageAgreements/${query.id}`,
        options,
      );
      if (domainModel.orderBrokerageAgreement.getViewModel) {
        return domainModel.orderBrokerageAgreement.getViewModel(result.data);
      }
      return result.data;
    },
  },

  entitySettlement: {
    list: async (query, req, options) => {
      const instance = await getAxiosInstance(req);
      // the catch handle cancel events, the code for cancel is in getAxiosInstance and actions

      const result = await instance
        .post(`entitySettlements/search`, query, options)
        .catch(() => null);
      if (!result) return undefined;
      if (domainModel.entitySettlement.getViewModel) {
        result.data.rows = result.data.rows.map(row => {
          return domainModel.entitySettlement.getViewModel(row);
        });
        return result.data;
      }
      return result.data;
    },
    get: async (query, req, options) => {
      const instance = await getAxiosInstance(req);
      const result = await instance.get(
        `entitySettlements/${query.id}`,
        options,
      );
      if (domainModel.entitySettlement.getViewModel) {
        return domainModel.entitySettlement.getViewModel(result.data);
      }
      return result.data;
    },
  },

  settlement: {
    list: async (query, req, options) => {
      const instance = await getAxiosInstance(req);
      // the catch handle cancel events, the code for cancel is in getAxiosInstance and actions

      const result = await instance
        .post(`settlements/search`, query, options)
        .catch(() => null);
      if (!result) return undefined;
      if (domainModel.settlement.getViewModel) {
        result.data.rows = result.data.rows.map(row => {
          return domainModel.settlement.getViewModel(row);
        });
        return result.data;
      }
      return result.data;
    },
    get: async (query, req, options) => {
      const instance = await getAxiosInstance(req);
      const result = await instance.get(`settlements/${query.id}`, options);
      if (domainModel.settlement.getViewModel) {
        return domainModel.settlement.getViewModel(result.data);
      }
      return result.data;
    },
  },
};

export default settlementDatalayer;
